import gql from 'graphql-tag';

export const CREATE_SERVICE = gql`
  mutation createService(
    $createServiceInput: CreateServiceInput!
    $serviceTasks: [CreateServiceTaskInput]
  ) {
    createService(
      createServiceInput: $createServiceInput
      serviceTasks: $serviceTasks
    ) {
      id
      branchId
    }
  }
`;

export const UPDATE_SERVICE = gql`
  mutation updateService(
    $id: Int!
    $updateServiceInput: UpdateServiceInput!
    $serviceTasks: [UpdateServiceTaskInput]
  ) {
    updateService(
      id: $id
      updateServiceInput: $updateServiceInput
      serviceTasks: $serviceTasks
    ) {
      id
      branchId
    }
  }
`;

export const REMOVE_SERVICE_TASK = gql`
  mutation removeServiceTask($id: Int!) {
    removeServiceTask(id: $id)
  }
`;
export const REMOVE_SERVICE_TASK_ASSIGNMENT = gql`
  mutation removeServiceTaskAssignment($id: Int!) {
    removeServiceTaskAssignment(id: $id)
  }
`;

export const REMOVE_SERVICE = gql`
  mutation removeService($id: Int!) {
    removeService(id: $id)
  }
`;
